import {ChangeDetectionStrategy, Component, Inject} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {GruppeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MedlemInvitasjonOpprettKomponent} from "../../komponenter/medlem-invitasjon-opprett/medlem-invitasjon-opprett";

export type MedlemInvitasjonOpprettDialogRespons = boolean;

export interface DialogParametre {
    gruppe: GruppeModell;
}

@Component({
    selector: 'medlem-invitasjon-opprett-dialog',
    templateUrl: './medlem-invitasjon-opprett-dialog.html',
    styleUrl: './medlem-invitasjon-opprett-dialog.scss',
    host: { 'class': 'e2e-medlem-invitasjon-opprett-dialog' },
    imports: [
        MatDialogModule,
        MedlemInvitasjonOpprettKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemInvitasjonOpprettDialogKomponent {

    static vis(dialog: MatDialog, gruppe: GruppeModell): MatDialogRef<MedlemInvitasjonOpprettDialogKomponent, MedlemInvitasjonOpprettDialogRespons> {
        return dialog.open(MedlemInvitasjonOpprettDialogKomponent, {
            data: {gruppe} as DialogParametre,
            disableClose: true,
            ariaLabelledBy: 'medlem-invitasjon-opprett-dialog-tittel',
            maxWidth: '900px',
            width: '100%'
        });
    }

    gruppe: GruppeModell;

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                public dialogRef: MatDialogRef<MedlemInvitasjonOpprettDialogKomponent, MedlemInvitasjonOpprettDialogRespons>) {
        this.gruppe = parametre.gruppe;
    }

    vedLagret() {
        this.dialogRef.close(true);
    }

    avbryt() {
        this.dialogRef.close(false);
    }
}
